import { TFunction } from 'i18next'
import z from 'zod'

export const makeCheckoutPackageSchema = (t: TFunction<['packages']>) =>
  z.object({
    comment: z
      .string()
      .max(200, t('packages:checkoutModal.validation.commentMaxLength'))
      .optional(),
  })
